export const RegExpValidation = {
    userAccount: /^[a-z0-9]$/,
    alphaNumeric: /^[a-zA-Z0-9 ]+$/,
    phoneNumber: /^[0-9]$/,
    email: /^[a-z0-9]+@[a-z0-9.-]+\.[a-z]{2,}$/,
    accountEmail: (account: string) => new RegExp(`^${account}@[a-z0-9.-]+\\.[a-z]{2,}$`),
}